import { createContext } from "react";

const DjContext = createContext({
  pendingDjs: [],
  setPendingDjs: () => {},
});

export default DjContext;
